/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFenceIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-fence"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.97 20.32Q5.42 20.32 5.05 19.95Q4.67 19.57 4.67 19.02L4.67 16.32L4 16.32Q3.45 16.32 3.06 15.94Q2.67 15.55 2.67 15Q2.67 14.45 3.06 14.06Q3.45 13.68 4 13.68L4.67 13.68L4.67 12.32L4 12.32Q3.45 12.32 3.06 11.94Q2.67 11.55 2.67 11Q2.67 10.45 3.06 10.06Q3.45 9.68 4 9.68L4.67 9.68L4.67 7.4Q4.67 7.13 4.76 6.9Q4.85 6.67 5.05 6.47L7.08 4.45Q7.45 4.08 8 4.08Q8.55 4.08 8.93 4.45L10 5.55L11.1 4.45Q11.47 4.08 12.01 4.08Q12.55 4.08 12.93 4.45L14.03 5.55L15.1 4.45Q15.47 4.08 16.01 4.08Q16.55 4.08 16.93 4.45L18.95 6.47Q19.15 6.67 19.25 6.9Q19.35 7.13 19.35 7.4L19.35 9.68L20 9.68Q20.55 9.68 20.94 10.06Q21.32 10.45 21.32 11Q21.32 11.55 20.94 11.94Q20.55 12.32 20 12.32L19.35 12.32L19.35 13.68L20 13.68Q20.55 13.68 20.94 14.06Q21.32 14.45 21.32 15Q21.32 15.55 20.94 15.94Q20.55 16.32 20 16.32L19.35 16.32L19.35 19.02Q19.35 19.57 18.98 19.95Q18.6 20.32 18.05 20.32ZM7.33 9.68L8.68 9.68L8.68 7.95L8 7.28L7.33 7.95ZM11.32 9.68L12.68 9.68L12.68 7.95L12 7.28L11.32 7.95ZM15.35 9.68L16.68 9.68L16.68 7.95L16 7.28L15.35 7.95ZM7.33 13.68L8.68 13.68L8.68 12.32L7.33 12.32ZM11.32 13.68L12.68 13.68L12.68 12.32L11.32 12.32ZM15.35 13.68L16.68 13.68L16.68 12.32L15.35 12.32ZM7.33 17.68L8.68 17.68L8.68 16.32L7.33 16.32ZM11.32 17.68L12.68 17.68L12.68 16.32L11.32 16.32ZM15.35 17.68L16.68 17.68L16.68 16.32L15.35 16.32Z" fill={color} />
    </svg>
  );
}
